













































































import { PropType, computed, defineComponent, ref } from '@vue/composition-api';

import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';

import { IRootState } from '@/store';
import {
  IRequisitionState,
  IRequisitionGetters,
  IRequisitionActions,
  IRequisitionMutations
} from '@/store/requisition';
import { IRequisition } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { requiredValidator } from '@/utils/validators';

import FormFieldInlineEditor from '../common/FormFieldInlineEditor.vue';

export default defineComponent({
  name: 'RequisitionProjectNumberEditor',

  components: {
    FormFieldInlineEditor
  },

  props: {
    requisition: {
      type: Object as PropType<IRequisition>,
      required: true
    },
    disabled: Boolean
  },

  setup(props, { emit }) {
    const isActive = ref(false);

    const error = ref<ISystemError | null>(null);

    function clearError() {
      error.value = null;
    }

    const isLoading = ref(false);

    const project = computed(() => {
      props;
      return props.requisition.project || 'No project number';
    });

    const store = useStore<IRootState>();

    const { useActions } = createNamespacedHelpers<
      IRequisitionState,
      IRequisitionGetters,
      IRequisitionActions,
      IRequisitionMutations
    >(store, 'requisition');

    const { updateRequisition } = useActions(['updateRequisition']);

    function saveRequisition(project: string) {
      isLoading.value = true;
      updateRequisition({
        id: props.requisition.id,
        project: project
      })
        .then(() => {
          isActive.value = false;
          emit('saved');
        })
        .catch(err => {
          error.value = setErrorFromAxiosError(err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    }

    function cancelHandler() {
      isActive.value = false;

      clearError();
    }

    return {
      error,
      isActive,
      isLoading,
      clearError,
      requiredValidator,
      project,
      saveRequisition,
      cancelHandler
    };
  }
});
